import React from "react";
import _map from "lodash/map";

import { StyledContainer } from "../styles";
import { StatisticItem } from "./StaticticItem";

const statisticData = [
  {
    label: "Total Organizations"
  },
  {
    label: "Total Tokens"
  },
  {
    label: "Total Users"
  }
];

const OrganizationsStatistics = ({ organizationsTotalStat, statsMap }) => {
  const isLoading = !organizationsTotalStat || !statsMap;

  const renderEmptyStatisticState = () => _map(statisticData, StatisticItem);

  if (isLoading) {
    return <StyledContainer>{renderEmptyStatisticState()}</StyledContainer>;
  }

  const totalUsers = statsMap.reduce((accumulator, o) => accumulator + o[1]?.users?.length, 0) || 0;
  const totalTokens = statsMap.reduce((accumulator, o) => accumulator + o[1]?.tokens?.length, 0) || 0;

  const values = [organizationsTotalStat?.organizations?.length, totalTokens, totalUsers];
  statisticData.forEach((item, index) => (item.value = values[index]));

  return <StyledContainer>{_map(statisticData, StatisticItem)}</StyledContainer>;
};

export default OrganizationsStatistics;
